import "./App.css";
import CustomNavbar from '../src/Components/Customnavbar.js';
// import Footer from '../src/components/Footer';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../node_modules/bootstrap/dist/js/bootstrap.bundle.js';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from '../src/Components/Home.js';
import AboutUs from "../src/Components/AboutUs.js";
import HowItswork from "../src/Components/Hows.js";
import Footer from "../src/Components/Footer.js";
import Pricing from "../src/Components/Pricing .js";
import Contact from "../src/Components/Contact.js";
import Case from "../src/Components/Case.js";
import Reviews from "../src/Components/Reviews.js";
import Getstarted from "../src/Components/Getstarted.js";


function App() {

  const footerInfo = {
    head2: "Find Us At",
    li11: "Pearl Square Hadapsar, Pune Maharashtra 411028.",
    // head99: "Find Us At",
    li99: "1218 pearl square, Atlanta United States.",
    head3: "Pages",
    li21: "Home",
    li22: "Pricing",
    li23: "CaseStudies",
    li24: "Reviews",
    li25: "Contact",
    li70: "Get-Started",
    li71: "About-Us",
    li72: "How It's Work",
    head4: "Have a Questions?",
    li29: "Terms and Conditions",
    li30: "Refund Policy",
    li32: "+91 9834429482",
    li33: "info.fusionsphere@gmail.com",
    copy: "©2025 fusionspherellp.com All rights reserved."
  };  

  return (
    <>
    <BrowserRouter>
      <CustomNavbar/>
        <Routes>
            <Route />
            <Route path="/" element={<Home />} />
            <Route path="/aboutus" element={<AboutUs />} />
            <Route path="/hows" element={<HowItswork  />} />
            <Route path="/pricing" element={<Pricing  />} />
            <Route path="/case-studies" element={<Case />} />
            <Route path="/reviews" element={<Reviews />} />
            <Route path="/contact" element={<Contact />} />
            
            <Route path="/get-started" element={<Getstarted />} />
           
            <Route/>
            
        </Routes>
        
        <Footer  info={footerInfo} />
    </BrowserRouter>
  </>
  );
}

export default App;

